import React from "react";

interface IRadioIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const RadioIcon: React.FC<IRadioIconProps> = ({ sizeX = 24, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#D0BDF8" strokeWidth="2"/>
            <circle cx="12" cy="12" r="5" fill="#D0BDF8"/>
        </svg>
    );
};
